import React, { createContext, useContext, useReducer } from 'react';
import { notificationsReducer, initialState } from './reducer';

const NotificationsContext = createContext();

export const NotificationsProvider = ({ children }) => {
    const [state, dispatch] = useReducer(notificationsReducer, initialState);

    return <NotificationsContext.Provider value={[state, dispatch]}>{children}</NotificationsContext.Provider>;
};

export const useNotificationsContext = () => {
    const context = useContext(NotificationsContext);
    if (!context) {
        throw new Error('useNotificationsContext must be used within a NotificationsProvider');
    }
    return context;
};
